import { ArrowRightLeft } from "lucide-react";
import Image from "next/image";
import LeadersCarousel from "./leaders-carousel";

type LeaderBoardHeroSectionProps = {
	noOfVIPsJoinedTillNow: number;
	noOfVIPConnections: number;
};

const LeaderBoardHeroSection = ({
	noOfVIPsJoinedTillNow,
	noOfVIPConnections,
}: LeaderBoardHeroSectionProps) => {
	return (
		<div className="relative flex w-full justify-center py-12 md:h-[512px] md:py-0">
			<div className="absolute inset-0 -bottom-[85%] -z-10 bg-gradient-to-b from-[rgba(0,_94,_255,_0.5)] to-[rgba(0,_94,_255,_0)]"></div>

			<div className="absolute inset-0 -z-10">
				<div className="relative h-full w-full after:absolute after:inset-0 after:bg-black/25">
					<Image
						src="/assets/img/bg/world.gif"
						alt="PropTechBuzz Leaderboard"
						width={600}
						height={338}
						className="h-full w-full object-cover"
					/>
				</div>
			</div>

			<div className="relative w-full">
				<div className="flex h-full w-full flex-col items-center justify-end gap-4 px-4 lg:px-0">
					<span className="bg-gradient-to-r from-white via-blue-400 to-white bg-clip-text py-1 text-center text-4xl font-bold text-transparent">
						Global PropTech Leaders Hive
					</span>
					<p className="text-center text-white opacity-50 lg:text-left">
						The only private network of global proptech leaders. Vetted. Verified.
					</p>

					<div className="my-8 flex w-full max-w-6xl flex-wrap items-center justify-between gap-6 md:flex-nowrap">
						<div className="flex flex-col gap-4">
							<span className="text-xl font-semibold text-white">
								{noOfVIPsJoinedTillNow}+ VIPs joined PropTechBuzz
							</span>

							<div className="h-1 w-16 rounded-lg bg-blue-500"></div>
						</div>

						<div className="flex items-center gap-2">
							<ArrowRightLeft className="h-6 w-6 text-white" />

							<span className="text-lg font-semibold text-white">
								{noOfVIPConnections} Connections
							</span>
						</div>
					</div>

					<div className="-mb-16 w-full">
						<LeadersCarousel />
					</div>
				</div>
			</div>
		</div>
	);
};

export default LeaderBoardHeroSection;
